import React, {useEffect, useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid} from '@mui/material'
import {InvoiceTrackerService} from '../../../../services';
import CustomDataGrid from '../../../../customUtil/DataGrid';


const InvoiceTracker = () => {
    const [list, setList] = useState([]);

 

    const columns = [
      {
          field: 'invoiceNumber', headerName: 'Invoice Number', width: 200,
          renderCell: (params) => (
              <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/integrations/onecp/invoiceTracker/' + params.row.id}>
                  {params.value}
              </Link>
          )
      },
      {field: 'orderNumber', headerName: 'PO', width: 200},
      {field: 'cpVoucherNumber', headerName: 'Voucher', width: 200},
      {field: 'status', headerName: 'Status', width: 200},   
      {field: 'asnNumber', headerName: 'ASN', width: 200},   
  ]

  
       useEffect(() => {
        InvoiceTrackerService.getAll()
               .then((response) => {
                 setList(response.data)                     
       });
       }, []);



        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Invoice Tracker</h1>
                    </header>
                  
                        <form>                            
                                <Grid container spacing={4}>
                                                
                                </Grid>                                                      
                              </form>
                              <Grid item xs={10}>&nbsp;</Grid>
                        <Grid item xs={12}>
                          <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               />
                          
                        </Grid>
                   
                </Container>
            </React.Fragment>
        );
}

export default InvoiceTracker;